//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Money } from 'v-money';

import metadadosCampoDinamicoComum from './metadadosCampoDinamicoComum';

export default {
  name: 'MetadadosCampoDinamicoDinheiro',
  props: {
    value: {
      type: [Number, String],
    },
  },
  mixins: [
    metadadosCampoDinamicoComum,
  ],
  components: {
    Money,
  },
  watch: {
    value: {
      immediate: true,
      handler(alterado) {
        this.valorInterno = alterado;
      },
    },
  },
  computed: {
    hasErrors() {
      if (!this.campoObrigatorio) {
        return false;
      }

      const val = this.valorInterno,
        hasErrors = (val === null || val === this.valorVazioDinheiro);
      return hasErrors;
    },
    validaCampo() {
      if (this.hasErrors) {
        return this.$t('message.campo_obrigatorio');
      }
      return null;
    },
  },
  data() {
    return {
      dirty: false,
      focused: false,
      valorInterno: null,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false,
      },
      valorVazioDinheiro: 0,
      rules: {
        requiredNome: () => {
          if (!this.campoObrigatorio || !this.hasErrors) {
            return true;
          }
          return this.$t('message.campo_obrigatorio');
        },
      },
    };
  },
  methods: {
    valorDinheiroAlterado(valor) {
      if (valor === this.value) return;
      this.$emit('input', valor);
      this.emiteValorAlterado(valor);
    },
  },
  mounted() {
    const input = document.getElementById(this.inputId);

    input.addEventListener('focus', () => {
      this.focused = true;
    }, false);

    input.addEventListener('keyup', () => {
      this.dirty = true;
    }, false);

    input.addEventListener('blur', () => {
      this.focused = false;
      this.dirty = true;
    }, false);
  },
};



// WEBPACK FOOTER //
// ./src/shared-components/metadados/campos-dinamicos/MetadadosCampoDinamicoDinheiro.vue?vue&type=script&lang=js&